import axios from '@axios'

const PREFIX = '/acessos'

export default {
  gerarTokenDuasEtapas(idUsuario, email) {
    return axios.post(`${PREFIX}/GerarTokenDuasEtapas/${idUsuario}/${email}`)
  },
  validarTokenDuasEtapas(tokenData) {
    return axios.post(`${PREFIX}/ValidarTokenDuasEtapas`, tokenData)
  },
}
